import { QueryKey } from 'react-query';
import { GeolocationData, Region } from '@water-web/types';

import { EndpointQuery } from '../../request';
import { queryKeys } from './queryKeys';

export class GeolocationQuery extends EndpointQuery<Region> {
  getKey(): QueryKey {
    return queryKeys.all;
  }

  async request(): Promise<Region> {
    const endpoint = 'https://geoip.getsquire.workers.dev/';
    let userRegions: Region | null = null;

    try {
      const response = await fetch(endpoint);
      const data: GeolocationData = await response.json();

      switch (data.country) {
        case 'US':
          userRegions = 'US';
          break;
        case 'CA':
          userRegions = 'CA';
          break;
        default:
          userRegions = 'EU';
          break;
      }

      return userRegions;
    } catch (error) {
      userRegions = 'OTHER';
      return userRegions;
    }
  }
}
